export enum FileModuleEnum {
  MERCHANT_REQUEST = 'MERCHANT_REQUEST',
  SHELF_TYPE = 'SHELF_TYPE',
  SHELF_INFORMATION = 'SHELF_INFORMATION',
  REFUND_REQUEST = 'REFUND_REQUEST',
  STORE_EXPENSE = 'STORE_EXPENSE'
}
